// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as SignupReqSelectionCardModuleScss from "../../styles/SignupReqSelectionCard.module.scss";

var styles = SignupReqSelectionCardModuleScss;

function SignupReqSelectionCardCmp(Props) {
  var card_data = Props.card_data;
  var requirement = Props.requirement;
  var click_handler = Props.click_handler;
  return React.createElement("div", {
              className: (
                requirement !== undefined ? requirement === card_data.requirement : false
              ) ? "" + styles["requirement-card-wrapper"] + " " + styles.selected + "" : styles["requirement-card-wrapper"],
              onClick: (function (param) {
                  Curry._1(click_handler, undefined);
                })
            }, React.createElement("div", {
                  className: styles["requirement-card"]
                }, React.createElement("div", {
                      className: styles["image-wrapper"]
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: card_data.requirement_icon.src,
                          height: card_data.requirement_icon.height,
                          width: card_data.requirement_icon.width,
                          quality: 75.0,
                          alt: card_data.requirement_icon.alt
                        })), React.createElement("div", {
                      className: styles["text-wrapper"]
                    }, React.createElement("p", {
                          className: styles.heading
                        }, card_data.heading), React.createElement("p", {
                          className: styles["sub-heading"]
                        }, card_data.sub_heading))), React.createElement("div", {
                  className: styles["checkbox-wrapper"]
                }, (
                  requirement !== undefined ? requirement === card_data.requirement : false
                ) ? React.createElement("div", {
                        className: styles["checkbox-selected"]
                      }, React.createElement("div", {
                            className: styles.selected
                          })) : React.createElement("div", {
                        className: styles.checkbox
                      })));
}

var make = SignupReqSelectionCardCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
